export const ErrorLoc = {
    noErrors: {
        ru: 'Нет ошибок',
        en: 'No errors'
    },
    requiredFields: {
        ru: 'Не заполнены необходимые поля.',
        en: 'Required fields are not filled.'
    },
    unknownError: {
        ru: 'Неизвестная ошибка',
        en: 'Unknown error'
    },
    permissionDenied: {
        ru: 'Для доступа к персональному разделу необходимо авторизоваться',
        en: 'To access the personal section you need to log in'
    },
    notFound: {
        one: {
            ru: 'Ошибка!! К сожалению, страница не найдена.',
            en: 'Error!! Sorry, the page was not found.'
        },
        two: {
            ru: 'Возможно, запрашиваемая Вами страница была перенесена или удалена.',
            en: 'The page you requested may have been moved or deleted.'
        },
        three: {
            ru: 'Вы можете попробовать ввести адрес еще раз, воспользоваться поиском или перейти на главную страницу.',
            en: 'You can try to enter the address again, use the search or go to the main page.'
        },
        toCabinet: {
            ru: 'Перейти в кабинет',
            en: 'Go to office'
        }
    },
    notify: {
        apiError: {
            ru: 'Ошибка сервера',
            en: 'Server error'
        },
        clientError: {
            ru: 'Ошибка на стороне клиента',
            en: 'Client side error'
        }
    }
};